




































































import stateMixin from "@/mixins/state";
import { AccountApi } from "@/api";

export default {
  data() {
    return {
      fields: {
        verificationPin: "",
        password: ""
      },
      valid: true,
      image: "",
      totp: {
        enabled: false,
        setup: {}
      },
      rules: {
        verificationPin: [v => !!v || "Code is verplicht"],
        password: [v => !!v || "Password is verplicht"]
      }
    };
  },
  mixins: [stateMixin],
  name: "TwoFactorAuthentication",
  mounted() {
    this.check();
  },
  methods: {
    reset() {
      this.$refs.form.reset();
    },
    async check() {
      this.setState(this.states.LOADING);
      try {
        const api = new AccountApi();
        const { data } = await api.accountIsTotpEnabled();
        this.reset();
        this.totp.enabled = data;
        if (!this.totp.enabled) {
          await this.init();
        } else {
          this.setState(this.states.INITIAL);
        }
      } catch {
        this.setState(this.states.ERROR);
      }
    },
    async init() {
      this.setState(this.states.LOADING);
      try {
        const api = new AccountApi();
        const { data } = await api.accountGetTotpSetupCode();
        this.totp.setup = data;
        this.setState(this.states.INITIAL);
      } catch {
        this.setState(this.states.ERROR);
      }
    },
    enable: async function() {
      this.setState(this.states.LOADING);
      try {
        const api = new AccountApi();
        const { data } = await api.accountEnableTotp({
          currentPassword: this.fields.password,
          verificationPin: this.fields.verificationPin
        });
        await this.check();
        if (!this.currentStateIs(this.states.ERROR)) {
          this.setState(this.states.COMPLETED);
        }
      } catch {
        this.setState(this.states.ERROR);
      }
    },
    async disable() {
      this.setState(this.states.LOADING);
      try {
        const api = new AccountApi();
        const { data } = await api.accountDisableTotp({
          currentPassword: this.fields.password,
          pin: this.fields.verificationPin
        });
        await this.check();
        if (!this.currentStateIs(this.states.ERROR)) {
          this.setState(this.states.COMPLETED);
        }
      } catch {
        this.setState(this.states.ERROR);
      }
    }
  }
};
